import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=67db117d&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports